module.exports = __webpack_public_path__ + "images/external_images/img/demo/real-estate/ss-author-5__.jpg";